<template>
  <router-view v-if="isAuthRoute"/>
  <v-app v-else-if="isLogged">
  <navigation/>
    <v-main v-bind:style="{ backgroundColor}">
      <router-view/>
    </v-main>
    <v-snackbar
      v-for="(message) in messages"
      :key="message.id"
      v-model="message.model"
      right
      dark
      top
      :timeout="2000">
      {{ message.text }}</v-snackbar>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  mounted() {
    // Bookaweb logo that displays in console
    const stringLogo = `
        ⬜⬜⬜⬜⬜
      ⬜           ⬜
      ⬜             ⬜
      ⬜     ⬜⬜    ⬜
      ⬜   ⬜    ⬜ ⬜
      ⬜   ⬜      ⬜
      ⬜   ⬜       ⬜
      ⬜    ⬜    ⬜  ⬜
      ⬜      ⬜⬜     ⬜
      ⬜                ⬜
      ⬜                ⬜
      ⬜               ⬜
        ⬜⬜⬜⬜⬜⬜⬜

      ${this.$t('Welcome to Bookaweb')}!
    `;
    console.log(stringLogo);

    if (window.navigator.userAgent.includes('cordova-app')) {
      window.isUsingApp = true;
    }
  },
  computed: {
    ...mapGetters([
      'isLogged', 'user', 'backgroundColor',
    ]),
    isAuthRoute() {
      return ['Login', 'Register', 'VerifyEmail', 'ResetPassword'].includes(this.$route.name);
    },
    messages: {
      get() {
        return this.$store.getters.messages;
      },
      set(newName) {
        return newName;
      },
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
        .finally(() => {
          this.$router.push('/login');
        });
    },
  },

};
</script>
